<!--
 * @Auther: liuguangsheng1
 * @Date: 2021-07-28 10:56:49
 * @LastEditTime: 2021-09-15 18:17:11
 * @Description: 
-->

<template>
    <div class="jdmall-portal-side">
        <SideMenu />
    </div>
</template>

<script>
import SideMenu from './sideMenu.vue'

export default {
    name: 'portalSide',
    components: {
        SideMenu,
    },
    props: {},
    data() {
        return {}
    },
    methods: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.jdmall-portal-side {
    margin-top: 48px;
    height: calc(100% - 48px);
    min-width: 168px;
    background: #fff;
    border-right: 1px solid #f2f2f5;
}
</style>
